import clsx from "clsx";
import Input from "../../input";
import { CheckboxControlProps } from "../types";

export default function CheckboxControl(
  props: Readonly<Omit<CheckboxControlProps, "type">>,
) {
  const { label, getInputRef, onChange, value, size = "md", ...rest } = props;
  const id = "checkbox-" + rest.name;
  return (
    <div className="flex align-middle gap-1">
      <Input
        {...rest}
        id={id}
        checked={value}
        size={size}
        ref={getInputRef}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange?.(e.target.checked)
        }
        type="checkbox"
      />
      <label
        htmlFor={id}
        className={clsx("cursor-pointer flex-1", {
          "text-sm": size === "sm",
          "text-base": size === "md",
          "text-xl": size === "lg",
        })}
      >
        {label}
      </label>
    </div>
  );
}
